import { Card, CardContent, CardHeader, CardTitle, Tabs, TabsList, TabsTrigger } from '@1trading/react';
import type { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const USER_AUDIT_PATH = '/operations/user-audit';
const ACCOUNT_CLEANUP_PATH = `${USER_AUDIT_PATH}/cleanup`;

const TABS = [
  { key: 'audit', label: 'Audit reports', to: USER_AUDIT_PATH },
  { key: 'cleanup', label: 'Account cleanup', to: ACCOUNT_CLEANUP_PATH },
] as const;

/** Card and tab header shared by the user-audit pages; each tab is its own route. */
export const UserAuditSection = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const activeTab = pathname.startsWith(ACCOUNT_CLEANUP_PATH) ? 'cleanup' : 'audit';

  const handleTabChange = (key: string) => {
    const tab = TABS.find((candidate) => candidate.key === key);
    if (tab) navigate(tab.to);
  };

  return (
    <Card>
      <CardHeader className="flex flex-row flex-wrap items-center justify-between gap-3 space-y-0">
        <CardTitle>User Audit</CardTitle>
        <Tabs onValueChange={handleTabChange} value={activeTab}>
          <TabsList>
            {TABS.map((tab) => (
              <TabsTrigger key={tab.key} value={tab.key}>
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
};
UserAuditSection.displayName = 'UserAuditSection';
